/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import MfaCodeEntry from '../../../contentViews/MfaCodeEntry';

import { authToken } from '../../../../utilities/LocalStorage';
import ContentWrapper from '../../../components/ContentWrapper';

import { ConnectedGrayPrivacyCard } from '../../../components/card/PrivacyCard';
import { PolicyName } from '../../../../models/PolicyModel';

class MfaVerifyMobileNumber extends React.Component {

  constructor(props) {
    super(props);

    this.submitMfaCode = this.submitMfaCode.bind(this);
    this.onChangeMfaCode = this.onChangeMfaCode.bind(this);
    this.onFocus = this.onFocus.bind(this);

    this.state = {
      mfaCode: '',
      errorMessage: '',
      token: authToken.get(),
      mfaCodeIsGoodEnough: false,
    };
  }

  onChangeMfaCode(value) {
    this.setState({
      mfaCode: value,
      mfaCodeIsGoodEnough: value.length > 5,
    });
    this.props.onChangeMfaCode(value);
  }

  onFocus() {
    this.setState({
      errorMessage: '',
    });
  }

  submitMfaCode() {
    if (this.state.mfaCodeIsGoodEnough) {
      this.props.submitMfaCode(this.state.mfaCode, (apiError) => {
        if (apiError) {
          this.setState({
            errorMessage: <FormattedMessage id={apiError.messageKey()} />,
          });
        } else {
          this.props.finishedVerifying();
        }
      });
    } else {
      this.setState({
        errorMessage: <FormattedMessage id="error.2fa-code-validator.message" />,
      });
    }
  }

  render() {
    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            submitDisabled={!this.state.mfaCodeIsGoodEnough}
            next={this.submitMfaCode}
            goBack={this.props.goBack}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText
                id="settings2FA.turnOnTitle.text"
              />
              <ContentWrapper>
                <ConnectedGrayPrivacyCard
                  name={PolicyName.MFA_PHONE_NUMBER}
                  subTitle="privacy.privacyBlock.2faPhoneNumber.teaser"
                  onWithdrawConsent={null}
                />
                <MfaCodeEntry
                  token={this.state.token}
                  isWaitingForMfa={true}
                  cancelMfaRoute=""
                  errorMessage={this.state.errorMessage}
                  mfaCode={this.state.mfaCode}
                  mobileNumber=""
                  submitMfaCode={this.submitMfaCode}
                  onChangeMfaCode={this.onChangeMfaCode}
                  onFocus={this.onFocus}
                  onResend={() => { this.setState({ errorMessage: '', mfaCode: '' }); }}
                />
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
MfaVerifyMobileNumber.propTypes = {
  submitMfaCode: PropTypes.func,
  onChangeMfaCode: PropTypes.func,
  finishedVerifying: PropTypes.func,
  goBack: PropTypes.func,
  isMfaEnabled: PropTypes.bool,
  mfaEnableIsInitated: PropTypes.bool,
};

export default MfaVerifyMobileNumber;
